{
  "common": {
    "brand": "Zoukessence",
    "tagline": "Die Essenz der Bewegung",
    "language": {
      "de": "DE",
      "en": "EN"
    },
    "cta": {
      "trial": "Schnupperlektion",
      "enroll": "Anmelden",
      "tickets": "Tickets",
      "more": "Mehr erfahren",
      "contact": "Kontakt aufnehmen",
      "newsletter": "Abonnieren",
      "start": "Loslegen"
    },
    "nav": {
      "home": "Home",
      "kurse": "Kurse",
      "events": "Events",
      "info": "Info",
      "about": "About",
      "kontakt": "Kontakt",
      "members": "Mitgliederbereich",
      "menuOpen": "Menü öffnen",
      "menuClose": "Menü schliessen"
    },
    "utility": {
      "studio": "Förrlibuckstrasse 62 · Zürich",
      "hours": "Mo — Sa",
      "phone": "+41 79 000 00 00",
      "email": "info@zoukessence.ch"
    },
    "footer": {
      "brandTagline": "Tanzschule für Brazilian Zouk, Lambada & Samba de Gafieira. Tanzstudio Silbando, Förrlibuckstrasse 62, 8005 Zürich. Seit 2015.",
      "kurseTitle": "Kurse",
      "modulA": "Modul A · Starter",
      "modulB": "Modul B · Improvers",
      "openLevel": "Open Level",
      "sambaGafieira": "Samba de Gafieira",
      "privateLink": "Privatstunden",
      "brandColTitle": "Zoukessence",
      "eventsLink": "Events",
      "ticketsLink": "Tickets & Anmeldung",
      "vereinLink": "Verein BZ Switzerland",
      "studioLabel": "Studio",
      "addressMultiline": "Förrlibuckstrasse 62\n8005 Zürich",
      "instagram": "Instagram",
      "facebook": "Facebook",
      "youtube": "YouTube",
      "copyright": "© {{year}} Zoukessence — Alle Rechte vorbehalten",
      "agb": "AGB",
      "privacy": "Datenschutz",
      "cookies": "Cookies"
    }
  },

  "home": {
    "seo": {
      "title": "Brazilian Zouk in Zürich",
      "description": "Tanzschule für Brazilian Zouk, Lambada & Samba de Gafieira. Tanzstudio Silbando, Förrlibuckstrasse 62, 8005 Zürich. Seit 2015."
    },
    "hero": {
      "eyebrow": "Tanzschule · Zürich · MMXXVI — Brazilian Zouk · Lambada · Samba de Gafieira",
      "titlePart1": "Tanze ",
      "titleItalic1": "brasilianisch",
      "titleConnector": ".\nIn ",
      "titleItalic2": "Zürich",
      "titlePart2": ".",
      "subtitlePlain": "Von null ",
      "subtitleItalic": "auf Floor.",
      "lede": "Eine Tanzschule für Brazilian Zouk, Lambada und Samba de Gafieira. Wir lehren den Fluss zwischen den Schritten, den Atem, das Gespräch zwischen zwei Tanzenden — von der ersten Lektion bis zur Social.",
      "primaryCta": "Starter Class buchen",
      "ghostCta": "Alle Kurse ansehen",
      "sideImageAlt": "Zoukessence Studio · Tanzklasse",
      "sideBadge": "Modul A · Neu",
      "sideQuote": "«Flow ist nicht ein Schritt — es ist die Pause dazwischen.»",
      "metaNext": "NÄCHSTER START",
      "metaNextDayPrefix": "Do ",
      "metaNextValue": "09.04.2026",
      "metaStudio": "MODUL A",
      "metaStudioValue": "6 × 75 min oder Weekender",
      "metaLanguage": "SPRACHE",
      "metaLanguageValue": "Deutsch / English",
      "metaCommunity": "COMMUNITY",
      "metaCommunityValue": "700+ Tänzer"
    },
    "marquee": ["Brazilian Zouk", "Lambada", "Samba de Gafieira"],
    "dances": {
      "eyebrow": "01 / Tänze",
      "title": "Drei Tänze,",
      "titleItalic": "eine Sprache.",
      "items": [
        {
          "idx": "01",
          "code": "Zouk",
          "tag": "Flow, Modern",
          "title": "Brazilian Zouk",
          "body": "Der modernste der brasilianischen Tänze. Wellenartige Bewegungen, Musikalität und Verbindung — getanzt zu moderner wie brasilianischer Musik.",
          "cta": "Was ist Brazilian Zouk?"
        },
        {
          "idx": "02",
          "code": "Lambada",
          "tag": "Passion, Original",
          "title": "Lambada",
          "body": "Der Ursprung. Schnellere Musik, mehr Drehung, hüftbetont — der leidenschaftliche Verwandte des Zouk, mit dem alles begann.",
          "cta": "Mehr zur Lambada"
        },
        {
          "idx": "03",
          "code": "Samba",
          "tag": "Tradition, Footwork",
          "title": "Samba de Gafieira",
          "body": "Der Ballsaal-Samba aus Rio. Schnelle Schritte, Drehungen und Verspieltheit — Tradition trifft auf brasilianische Lebensfreude.",
          "cta": "Mehr zu Samba"
        }
      ]
    },
    "modul": {
      "eyebrow": "02 / Starter Class",
      "titlePart1": "Modul A. Von null ",
      "titleItalic": "auf Floor.",
      "lede": "Sechs Abende oder ein konzentriertes Wochenende. Wähle, was zu deinem Tempo passt — die Inhalte sind die gleichen.",
      "cta": "Anmelden",
      "cards": [
        {
          "label": "Abendkurs · klassisch",
          "title": "Modul A — Donnerstag-Serie",
          "meta": "6 × 75 min · Do · 19:00 · Anfänger",
          "body": "Sechs Wochen, ein Abend pro Woche. Zeit, um zu verarbeiten, zu fragen und zwischen den Lektionen zu üben. Empfohlen für alle, die in Ruhe einsteigen wollen.",
          "dates": [
            { "date": "Do, 09.04. — 14.05.2026", "season": "Frühling" },
            { "date": "Do, 21.08. — 25.09.2026", "season": "Sommer" }
          ],
          "price": "CHF 230"
        },
        {
          "label": "Weekender · Neu",
          "title": "Modul A — Wochenend-Intensiv",
          "meta": "2 × 3.5 h · Sa+So Vormittag · Anfänger",
          "body": "Dieselben Inhalte, an zwei Vormittagen. Schneller, intensiver, mit Zeit für die kleinen Details, die später den Unterschied machen.",
          "dates": [
            { "date": "Sa+So, 14./15.03.2026", "season": "März" },
            { "date": "Sa+So, 18./19.04.2026", "season": "April" },
            { "date": "Sa+So, 13./14.06.2026", "season": "Juni" }
          ],
          "price": "CHF 230"
        }
      ]
    },
    "schedule": {
      "eyebrow": "03 / Kursplan",
      "title": "Was läuft",
      "titleItalic": "diese Woche.",
      "lede": "Wochenplan. Drop-in möglich, Anmeldung empfohlen. Alle Module bauen aufeinander auf — Wechsel jederzeit möglich nach Absprache.",
      "rows": [
        {
          "day": "Mo",
          "time": "19:00",
          "title": "Brazilian Zouk · Modul B",
          "pills": [
            { "label": "Modul B", "variant": "wine" },
            { "label": "Improvers", "variant": "ghost" }
          ],
          "desc": "Drehungen, Lateral & Cambré-Grundlagen.",
          "price": "CHF 290",
          "cta": "Anmelden"
        },
        {
          "day": "Mi",
          "time": "20:15",
          "title": "Samba de Gafieira · Foundations",
          "pills": [
            { "label": "Open Level", "variant": "verde" },
            { "label": "Footwork", "variant": "ghost" }
          ],
          "desc": "8 × 75 min · Marisa & Rogério.",
          "price": "CHF 290",
          "cta": "Anmelden"
        },
        {
          "day": "Do",
          "time": "19:00",
          "title": "Brazilian Zouk · Starter Class (Modul A)",
          "pills": [
            { "label": "Modul A", "variant": "ember" },
            { "label": "Anfänger", "variant": "ghost" }
          ],
          "desc": "6 × 75 min · ab 09.04.2026.",
          "price": "CHF 230",
          "cta": "Anmelden"
        },
        {
          "day": "Do",
          "time": "20:30",
          "title": "Lambada · Open Level",
          "pills": [
            { "label": "Open Level", "variant": "ghost" },
            { "label": "Drop-in", "variant": "ghost" }
          ],
          "desc": "75 min · alle Levels willkommen.",
          "price": "CHF 25",
          "cta": "Drop in"
        },
        {
          "day": "Fr",
          "time": "21:00",
          "title": "Practica & Social",
          "pills": [
            { "label": "Community", "variant": "solid" },
            { "label": "DJ & Floor", "variant": "ghost" }
          ],
          "desc": "Üben, fragen, social tanzen. 2× pro Monat.",
          "price": "CHF 15",
          "cta": "Reservieren"
        }
      ]
    },
    "challenge": {
      "eyebrow": "04 / Workshop · April 2026",
      "title": "Zouk",
      "titleItalic": "Challenge.",
      "lede": "Drei Donnerstage, drei Themen, zwei Lehrer aus Brasilien. Stellst du dich der Challenge?",
      "bannerAlt": "Zouk Challenge 2026",
      "cards": [
        {
          "date": "16 · April · 2026",
          "code": "Furacão",
          "title": "Hurricane.",
          "desc": "Die schnelle, rotierende Bewegungsfigur — Technik, Sicherheit und Style."
        },
        {
          "date": "23 · April · 2026",
          "code": "Free Time",
          "title": "Improvise.",
          "desc": "Was tun, wenn die Musik stillsteht? Pausen als Werkzeug, nicht als Lücke."
        },
        {
          "date": "30 · April · 2026",
          "code": "Process",
          "title": "Choreographic.",
          "desc": "Wie aus zwei Bewegungen eine Phrase wird. Komposition für Paare."
        }
      ],
      "footTime": "19:00 · 2 Stunden",
      "footWith": "mit ",
      "footTeachers": "Marisa Silva & Rogério Almeida",
      "footPrice": "CHF 120",
      "footPriceSuffix": " für alle drei Termine",
      "cta": "Plätze sichern"
    },
    "team": {
      "eyebrow": "05 / Team",
      "title": "Die Lehrer,",
      "titleItalic": "die dich tragen.",
      "lede": "Vier Tänzer mit zusammen über 60 Jahren Plan-Erfahrung. Wir unterrichten so, wie wir selbst gerne gelernt hätten — präzise, geduldig und mit Humor.",
      "items": [
        {
          "name": "Manuel Mühlebach",
          "role": "Gründer · Lehrer",
          "specs": "Brazilian Zouk · Lambada",
          "bio": "Gründer von Zoukessence. Unterrichtet seit 2015 — Schwerpunkt Verbindung, Musikalität und brasilianische Lebensfreude."
        },
        {
          "name": "Corinne Hardegger",
          "role": "Lehrerin · Co-Lead",
          "specs": "Brazilian Zouk",
          "bio": "Co-Lead der Brazilian-Zouk-Module. Geduldige Technikvermittlung mit Auge fürs Detail — seit 2017 im Team."
        },
        {
          "name": "Michelle Danuser",
          "role": "Lehrerin",
          "specs": "Brazilian Zouk · Samba de Gafieira",
          "bio": "Brazilian Zouk und Samba de Gafieira. Verbindet präzise Footwork mit musikalischem Spielraum — seit 2019 im Team."
        },
        {
          "name": "Cyrill Kernwein",
          "role": "Lehrer",
          "specs": "Brazilian Zouk · Improver",
          "bio": "Improver-Spezialist. Bringt komplexe Bewegungsfiguren in klare, verständliche Schritte — seit 2020 dabei."
        }
      ]
    },
    "community": {
      "eyebrow": "06 / Community",
      "title": "Eine Tanzschule,",
      "titleItalic": "ein Freundeskreis.",
      "lede": "Bei Zoukessence sind wir mehr als eine Schule — Practicas, Parties, Reisen und der Verein Brazilian Zouk Switzerland.",
      "splitTextPart1": "Wir unterrichten nicht nur Schritte — wir unterrichten die ",
      "splitTextItalic": "Menschen",
      "splitTextPart2": ", die tanzen.",
      "stats": [
        { "n": "700", "suffix": "+", "label": "Tänzer", "small": "in der Community seit 2014" },
        { "n": "24", "suffix": "×", "label": "Parties pro Jahr", "small": "Practicas, Socials, Festivals" },
        { "n": "6", "suffix": "/yr", "label": "Auslandsreisen", "small": "Lissabon · Rio · Tarifa · Berlin" },
        { "n": "12", "suffix": "+", "label": "Jahre Unterricht", "small": "in Zürich, seit 2014" }
      ],
      "eventsHeading": "Nächste Events",
      "events": [
        { "num": "22", "mon": "Mai 26", "title": "A Noite Brasileira", "sub": "Studio Silbando · 20:00 · DJ Patati" },
        { "num": "12", "mon": "Jun 26", "title": "Zouk Focus Day", "sub": "Workshops & Social · Marisa & Rogério" },
        { "num": "04", "mon": "Jul 26", "title": "Sommerfest am Wasser", "sub": "Limmat · open-air practica + grill" },
        { "num": "29", "mon": "Aug 26", "title": "Lisbon Zouk Weekend", "sub": "Group trip · 4 Tage · 20 Plätze" }
      ]
    },
    "testimonials": {
      "eyebrow": "07 / Stimmen",
      "title": "Was unsere",
      "titleItalic": "Tänzer",
      "titleTail": "sagen.",
      "items": [
        {
          "body": "Ich kam ohne Tanzerfahrung. Nach Modul A habe ich an meiner ersten Practica getanzt — und es hat tatsächlich funktioniert.",
          "initial": "N",
          "name": "Nina K.",
          "meta": "Modul A · 2025"
        },
        {
          "body": "Die Lehrer erklären nicht nur das was, sondern das warum. Das macht den Unterschied.",
          "initial": "D",
          "name": "David B.",
          "meta": "Open Level · 2 Jahre"
        },
        {
          "body": "Mehr als eine Tanzschule. Ich habe hier Freundschaften gemacht, die längst über das Studio hinausgehen.",
          "initial": "A",
          "name": "Andrea R.",
          "meta": "Community seit 2017"
        }
      ]
    },
    "faq": {
      "eyebrow": "08 / Häufige Fragen",
      "titlePart1": "Fragen,",
      "titleItalic": "bevor du startest.",
      "ledePart1": "Mehr Infos auf ",
      "ledeLink1": "Kurse",
      "ledeConnector": " und ",
      "ledeLink2": "Info",
      "ledePart2": " — oder schreib uns direkt.",
      "items": [
        {
          "q": "Brauche ich einen Partner für die Anmeldung?",
          "a": "Nein. Wir balancieren die Kurse — du musst nichts mitbringen ausser bequeme Schuhe und Lust auf Bewegung. Im Unterricht wechseln wir die Paare regelmässig."
        },
        {
          "q": "Was ziehe ich an?",
          "a": "Bequeme Kleidung in der du dich frei bewegen kannst, und Schuhe mit glatter Sohle (keine Sneaker mit Profil — die bleiben am Boden kleben). Tanzschuhe sind ab Modul B sinnvoll."
        },
        {
          "q": "Wann starten die nächsten Kurse?",
          "a": "Modul A startet am Do, 09.04.2026 (Abendserie) und als Weekender am Sa+So, 14./15.03., 18./19.04. und 13./14.06.2026."
        },
        {
          "q": "Wie viel kostet ein Kurs?",
          "a": "Modul A (Starter Class) kostet CHF 230. Folgemodule CHF 290. Drop-in für Open Level CHF 25. Mitglieder von «Brazilian Zouk Switzerland» erhalten 10% Rabatt."
        },
        {
          "q": "Ich kann nur einen Termin verpassen — gibt es ein Make-up?",
          "a": "Ja — du kannst eine verpasste Lektion in einem anderen Open-Level- oder Modul-A-Kurs nachholen. Sag uns einfach vorher Bescheid."
        },
        {
          "q": "Gibt es Online-Kurse?",
          "a": "Nein. Wir konzentrieren uns auf den Unterricht im Studio und auf unsere Workshops & Events — Tanzen lernt man auf dem Floor, nicht vor dem Bildschirm."
        }
      ]
    },
    "newsletter": {
      "eyebrow": "09 / Newsletter",
      "titlePart1": "Komm vorbei. ",
      "titleItalic": "Bleib in Kontakt.",
      "lede": "Einmal im Monat: neue Kurs-Daten, Events, Reisen und ein kurzer Tipp aus dem Studio. Kein Spam, jederzeit abbestellbar.",
      "placeholder": "deine@email.ch",
      "cta": "Anmelden",
      "contactLine": "Oder schreib uns: info@zoukessence.ch"
    }
  },

  "kurse": {
    "seo": {
      "title": "Kurse",
      "description": "Brazilian Zouk, Lambada und Samba de Gafieira in Zürich. Trial Class, Starter A–D, Improver 1–4, Intermediate, Advanced, Privatstunden — alle Termine 2026."
    },
    "hero": {
      "eyebrow": "Kurse · 2026 · Brazilian Zouk · Samba de Gafieira · Privat",
      "titleLine1": "Von der ersten Stunde",
      "titleLine2": "bis zur Advanced Class.",
      "intro": "Sechs Module Starter & Improver, gefolgt von Intermediate und Advanced — eine klare Lernstruktur für Brazilian Zouk. Dazu Samba de Gafieira, Trial Classes, Privatstunden und Wochenend-Intensivkurse."
    },
    "lernpfad": {
      "idx": "01 / Lernpfad",
      "title": "Trial → Advanced.",
      "sub": "Sechs Stufen, klare Reihenfolge. Du wechselst in die nächste Stufe, sobald die Bausteine sitzen — wir helfen bei der Einstufung.",
      "steps": [
        { "ix": "00", "lvl": "Schnupperlektion", "title": "Trial", "body": "Eine Stunde, kein Risiko. CHF 25." },
        { "ix": "01 – 04", "lvl": "Starter", "title": "Modul A — D", "body": "Grundschritt, Connection, erste Figuren. Vier Module à 6 × 75 min." },
        { "ix": "05 – 08", "lvl": "Improver", "title": "Improver 1 — 4", "body": "Headmovements, Lateral, Soltinho. Aufeinander aufbauend." },
        { "ix": "09", "lvl": "Intermediate", "title": "Intermediate", "body": "Offene Stufe. Quartalsweise einsteigen." },
        { "ix": "10", "lvl": "Advanced", "title": "Advanced", "body": "Marisa & Rogério · Mi 20:45." },
        { "ix": "X", "lvl": "1-zu-1", "title": "Privat Stunden", "body": "Eine Stunde, zwei Augen. Ab CHF 140." }
      ]
    },
    "sections": [
      {
        "id": "zouk",
        "intro": "Vom Schnupperkurs bis zur Advanced Class — vier Stufen, klare Progression, ohne Hetze. Du wechselst die Stufe, sobald du die Bausteine sitzen hast.",
        "style": "Brazilian Zouk",
        "trial": {
          "code": "Trial",
          "level": "Schnupperlektion",
          "title": "Brazilian Zouk · Trial",
          "body": "Erste 75 Minuten. Keine Vorkenntnisse, kein Partner nötig. CHF 25 wird beim Eintritt in einen Starter angerechnet.",
          "duration": "1 × 75 Min",
          "teacher": "Manuel & Corinne",
          "abendkurs": { "start": "Do 14.05.2026 · 19:00", "weeks": "Einmalig" },
          "price": "CHF 25",
          "cta": "Reservieren"
        },
        "modules": [
          {
            "code": "A",
            "level": "Starter",
            "title": "Starter A — Erste Schritte",
            "body": "Grundschritt, Frame, Connection und das erste Bodywave-Konzept. Aus dem Stand zum strukturierten Tanz.",
            "duration": "8 × 75 Min",
            "teacher": "Manuel & Corinne",
            "abendkurs": { "start": "Mo 12.01.2026 · 19:00", "weeks": "12.01.–02.03." },
            "weekender": { "start": "Sa+So 24.–25.01.2026", "weeks": "Intensiv-Wochenende" },
            "price": "CHF 280"
          },
          {
            "code": "B",
            "level": "Starter",
            "title": "Starter B — Bewegung verbinden",
            "body": "Erste Drehfiguren, sauberes Lead/Follow, Musikalitäts-Übungen.",
            "duration": "8 × 75 Min",
            "teacher": "Cyrill & Andrea",
            "abendkurs": { "start": "Mo 16.03.2026 · 19:00", "weeks": "16.03.–04.05." },
            "weekender": { "start": "Sa+So 21.–22.03.2026", "weeks": "Intensiv-Wochenende" },
            "price": "CHF 280"
          },
          {
            "code": "C",
            "level": "Starter",
            "title": "Starter C — Headmovements",
            "body": "Erste Cambré, weiche Übergänge in den Oberkörper, Tanz-Tempo-Spiel.",
            "duration": "8 × 75 Min",
            "teacher": "Michelle & Cyrill",
            "abendkurs": { "start": "Mo 18.05.2026 · 19:00", "weeks": "18.05.–06.07." },
            "weekender": { "start": "Sa+So 23.–24.05.2026", "weeks": "Intensiv-Wochenende" },
            "price": "CHF 280"
          },
          {
            "code": "D",
            "level": "Starter",
            "title": "Starter D — Übergänge",
            "body": "Sequenzen aus Modul A–C, Übergangs-Musikalität, erste Lateralbewegung.",
            "duration": "8 × 75 Min",
            "teacher": "Andrea & Amanda",
            "abendkurs": { "start": "Mo 31.08.2026 · 19:00", "weeks": "31.08.–19.10." },
            "weekender": { "start": "Sa+So 12.–13.09.2026", "weeks": "Intensiv-Wochenende" },
            "price": "CHF 280"
          },
          {
            "code": "I1",
            "level": "Improver",
            "title": "Improver 1 — Headmovements Basis",
            "body": "Cambré, Mergulho, kontrollierte Kopfbewegungen über mehrere Achsen.",
            "duration": "10 × 75 Min",
            "teacher": "Manuel & Michelle",
            "abendkurs": { "start": "Mi 14.01.2026 · 19:00", "weeks": "14.01.–18.03." },
            "price": "CHF 360"
          },
          {
            "code": "I2",
            "level": "Improver",
            "title": "Improver 2 — Lateralbewegung",
            "body": "Bewegungsfreiheit ohne Schritt, Furacão-Vorbereitung, Brustkorbisolation.",
            "duration": "10 × 75 Min",
            "teacher": "Cyrill & Amanda",
            "abendkurs": { "start": "Mi 25.03.2026 · 19:00", "weeks": "25.03.–27.05." },
            "price": "CHF 360"
          },
          {
            "code": "I3",
            "level": "Improver",
            "title": "Improver 3 — Musikalität",
            "body": "Phrasing, Counter-Tempo, Akzent-Setzung. Tanz, der den Song erzählt.",
            "duration": "10 × 75 Min",
            "teacher": "Manuel & Corinne",
            "abendkurs": { "start": "Mi 03.06.2026 · 19:00", "weeks": "03.06.–05.08." },
            "price": "CHF 360"
          },
          {
            "code": "I4",
            "level": "Improver",
            "title": "Improver 4 — Soltinho",
            "body": "Schnelle Tempi, Soltinho-Familie, anspruchsvolle Übergänge.",
            "duration": "10 × 75 Min",
            "teacher": "Cyrill & Andrea",
            "abendkurs": { "start": "Mi 19.08.2026 · 19:00", "weeks": "19.08.–21.10." },
            "price": "CHF 360"
          },
          {
            "code": "INT",
            "level": "Intermediate",
            "title": "Intermediate — Open Level",
            "body": "Laufender Kurs. Quartalsweise einsteigen, Fokusthemen wechseln.",
            "duration": "Mo 19:00 · 75 Min",
            "teacher": "Manuel & Corinne",
            "abendkurs": { "start": "Quartalsweise", "weeks": "Ganzjährig" },
            "price": "CHF 120 / Monat"
          },
          {
            "code": "ADV",
            "level": "Advanced",
            "title": "Advanced — Marisa & Rogério",
            "body": "Internationales Niveau, Technik-Tiefe, Connection und Improvisation.",
            "duration": "Mi 20:45 · 75 Min",
            "teacher": "Marisa & Rogério",
            "abendkurs": { "start": "Quartalsweise", "weeks": "Ganzjährig" },
            "price": "CHF 140 / Monat"
          }
        ]
      },
      {
        "id": "samba",
        "intro": "Der Ballsaal-Samba aus Rio. Beinarbeit, Spielfreude, Augenkontakt. Erst seit 2025 im Studio — jetzt mit eigener Linie.",
        "style": "Samba de Gafieira",
        "trial": {
          "code": "Trial",
          "level": "Schnupperlektion",
          "title": "Samba de Gafieira · Trial",
          "body": "Eine Stunde, ein neues Tempo. Keine Vorkenntnisse, paar wechselt, Sohle wichtig.",
          "duration": "1 × 75 Min",
          "teacher": "Michelle & Amanda",
          "abendkurs": { "start": "Do 21.05.2026 · 19:00", "weeks": "Einmalig" },
          "price": "CHF 25",
          "cta": "Reservieren"
        },
        "modules": [
          {
            "code": "A",
            "level": "Modul",
            "title": "Modul A — Tempo & Contratempo",
            "body": "Grundschritt, Tempo-Wechsel und Bota-Fora als Einstiegsfigur.",
            "duration": "8 × 75 Min",
            "teacher": "Michelle & Amanda",
            "abendkurs": { "start": "Do 22.01.2026 · 19:00", "weeks": "22.01.–12.03." },
            "price": "CHF 280"
          },
          {
            "code": "B",
            "level": "Modul",
            "title": "Modul B — Picadinhos",
            "body": "Kleine schnelle Schritte, Frame-Spiel, Spielfreude in der Connection.",
            "duration": "8 × 75 Min",
            "teacher": "Michelle & Andrea",
            "abendkurs": { "start": "Do 26.03.2026 · 19:00", "weeks": "26.03.–14.05." },
            "price": "CHF 280"
          },
          {
            "code": "C",
            "level": "Modul",
            "title": "Modul C — Balão Apagado",
            "body": "Folgt — folgt ab Herbst 2026.",
            "duration": "8 × 75 Min",
            "teacher": "t.b.a.",
            "price": "folgt"
          },
          {
            "code": "D",
            "level": "Modul",
            "title": "Modul D — Caminhada",
            "body": "Folgt — folgt ab Herbst 2026.",
            "duration": "8 × 75 Min",
            "teacher": "t.b.a.",
            "price": "folgt"
          }
        ]
      },
      {
        "id": "lambada",
        "intro": "Der Ursprung von Brazilian Zouk. Schneller, hüftbetont, voller Drehungen. Workshops und Open-Level-Lektionen.",
        "style": "Lambada",
        "modules": [
          {
            "code": "OL",
            "level": "Open Level",
            "title": "Lambada · Open Level",
            "body": "Drop-in jeden Donnerstag um 20:30. Beweglich, schnell, leidenschaftlich.",
            "duration": "Do 20:30 · 75 Min",
            "teacher": "Manuel & Corinne",
            "abendkurs": { "start": "wöchentlich", "weeks": "Ganzjährig · Drop-in" },
            "price": "CHF 25 / Drop-in"
          }
        ]
      }
    ],
    "privatstunden": {
      "idx": "05 / Privatstunden",
      "title": "Privat.",
      "italic": "Eins-zu-eins.",
      "cta": "Privatstunde anfragen",
      "title2": "Privatstunden",
      "body": "Eine Stunde, zwei Augen, ein Ziel. Wir arbeiten an dem, was dich gerade hält — Connection, Technik, Choreographie, Wettkampf.",
      "rates": [
        { "label": "1 Stunde", "value": "CHF 140 / 60 Min" },
        { "label": "5er Block", "value": "CHF 650 / 5 × 60 Min", "note": "−7% gegenüber Einzel" },
        { "label": "10er Block", "value": "CHF 1240 / 10 × 60 Min", "note": "−11% gegenüber Einzel" }
      ]
    },
    "preise": {
      "idx": "06 / Preise",
      "title": "Klar",
      "italic": "gerechnet.",
      "sub": "Module sind ein Fixpreis. Monatsabos beim Open Level. BZ-Switzerland-Mitglieder bekommen −10%.",
      "bestsellerBadge": "Bestseller",
      "items": [
        { "label": "Schnupperlektion", "value": "CHF 25", "note": "Wird bei Anmeldung angerechnet." },
        { "label": "Modul · 8 × 75 Min", "value": "CHF 280", "note": "Starter A–D, Samba A–D." },
        { "label": "Improver · 10 × 75 Min", "value": "CHF 360", "note": "Improver 1–4 Brazilian Zouk." },
        { "label": "Monatsabo · Intermediate", "value": "CHF 120", "note": "Open Level, jederzeit beitreten." }
      ],
      "infobar": [
        { "label": "BZ Switzerland", "value": "−10% mit Vereinsmitgliedschaft" },
        { "label": "Make-up", "value": "Eine Stunde nachholen pro Modul inklusive" },
        { "label": "Zahlung", "value": "TWINT · Karte · Banküberweisung" },
        { "label": "Anmeldefrist", "value": "1 Woche vor Modul-Start" }
      ],
      "ctaPrimary": "Jetzt anmelden",
      "ctaSecondary": "Stile vergleichen"
    }
  },

  "events": {
    "seo": {
      "title": "Events",
      "description": "Zoukdays Zürich · Samba Weekend · Zouk Focus Days · Zouk Challenge. Festivals und Workshops 2026 mit internationalen Gästen."
    },
    "hero": {
      "eyebrow": "Events · 2026 · Workshops · Festivals · Socials",
      "titleLine1": "Komm tanzen.",
      "titleLine2": "Bleib bis spät.",
      "intro": "Zwei Festivals, sechs Focus Days, vier internationale Gäste, mehrere Practicas. Alles, was 2026 läuft.",
      "stats": [
        { "label": "Festivals", "value": "2" },
        { "label": "Focus Days", "value": "6" },
        { "label": "Internationale Gäste", "value": "4" },
        { "label": "Format", "value": "Workshop + Social" }
      ]
    },
    "featured": {
      "idxLabel": "Featured · 2026"
    },
    "featuredItems": [
      {
        "slug": "zoukdays-zuerich-2026",
        "ord": "N° 01",
        "title": "Zoukdays Zürich 2026",
        "dateLabel": "20.–22. März 2026",
        "location": "Tanzstudio Silbando · Zürich-West",
        "guests": "Nina Indigo & Matheus Cabral",
        "body": "Drei Tage Brazilian Zouk in Zürich. Workshops am Tag, Socials in der Nacht. Internationale Gastlehrer, drei Niveaus parallel.",
        "highlights": [
          "Workshops auf 3 Niveaus · Beginner / Improver / Advanced",
          "Friday Welcome · Saturday Gala · Sunday Brunch-Social",
          "Verein-Mitglieder −10% · BZ Switzerland"
        ],
        "format": "Festival · Workshops + Socials"
      },
      {
        "slug": "samba-weekend-2026",
        "ord": "N° 02",
        "title": "Samba Weekend Zürich",
        "dateLabel": "27. Feb. – 01. März 2026",
        "location": "Tanzstudio Silbando · Zürich-West",
        "guests": "Gustavo Tomé & Fernanda d’Andrea",
        "body": "Gafieira und No Pé über drei Tage. Vom musikalischen Basis-Spiel bis zur Show-Choreographie aus Rio.",
        "highlights": [
          "Samba de Gafieira · Samba No Pé · Samba im Paar",
          "Friday Practica · Saturday Roda · Sunday Show",
          "Brunch & Live-Musik · inklusive im Pass"
        ],
        "format": "Festival · Workshops + Live-Musik"
      }
    ],
    "focusDays": {
      "idx": "04 / Zouk Focus Days",
      "title": "Jeden ersten",
      "italic": "Sonntag.",
      "sub": "Drei Stunden konzentriert. Brazilian-Zouk-Technik, Connection, Musikalität — jeden Monat ein anderer Fokus. Im Anschluss „Zunday Zocial\".",
      "info": {
        "schedule": "So 14:00–17:00 · CHF 45",
        "headline": "Open für alle Stufen ab Modul A.",
        "body": "Drei Stunden Workshop, ein gemeinsames Znacht, das Zunday Zocial im Studio bis spät. Reservation hilft uns bei der Planung — Walk-ins willkommen, solange Platz da ist.",
        "cta": "Platz reservieren"
      },
      "card": {
        "labelNext": "Nächster",
        "labelDefault": "Termin"
      },
      "items": [
        { "date": "So 04.01.2026", "topic": "Headmovements · Connection" },
        { "date": "So 01.02.2026", "topic": "Lateral · Furacão" },
        { "date": "So 01.03.2026", "topic": "Musikalität · Phrasing" },
        { "date": "So 05.04.2026", "topic": "Soltinho · Tempo" }
      ]
    },
    "kalender": {
      "idx": "05 / Voller Kalender 2026",
      "title": "Alles im",
      "italic": "Überblick.",
      "sub": "Chronologische Liste aller Events 2026. Featured-Items sind die zwei Festivals und die Zouk Challenge.",
      "pillFeatured": "Featured",
      "pillReservation": "Reservation",
      "items": [
        { "date": "04.01.2026", "title": "Zouk Focus Day · Januar", "format": "Workshop · 14:00–17:00" },
        { "date": "01.02.2026", "title": "Zouk Focus Day · Februar", "format": "Workshop · 14:00–17:00" },
        { "date": "27.02.–01.03.2026", "title": "Samba Weekend Zürich", "format": "Festival" },
        { "date": "01.03.2026", "title": "Zouk Focus Day · März", "format": "Workshop · 14:00–17:00" },
        { "date": "20.–22.03.2026", "title": "Zoukdays Zürich 2026", "format": "Festival" },
        { "date": "05.04.2026", "title": "Zouk Focus Day · April", "format": "Workshop · 14:00–17:00" },
        { "date": "09.–23.04.2026", "title": "Zouk Challenge · Marisa & Rogério", "format": "Workshop-Reihe · 3 × Do" }
      ]
    },
    "warum": {
      "idx": "06 / Warum Events",
      "title": "Tanz lebt vom",
      "italic": "Zusammenkommen.",
      "sub": "Workshops, Socials, Festivals — drei Formate, ein Ziel: die Schule ins Studio bringen und das Studio in die Stadt.",
      "cards": [
        { "kicker": "Workshop", "title": "Tief in ein Thema.", "body": "Drei Stunden Fokus, weniger Lärm. Du gehst mit einem konkreten Werkzeug nach Hause." },
        { "kicker": "Social", "title": "Tanze mit allen.", "body": "Practica und Socials nach Workshops — die Bewegung lebt im Wechsel." },
        { "kicker": "Festival", "title": "Drei Tage Eintauchen.", "body": "Internationale Lehrpersonen, Workshops parallel, Gala-Nacht. Einmal pro Halbjahr." }
      ]
    }
  },

  "info": {
    "seo": {
      "title": "Info — Tanzwissen & Glossar",
      "description": "Vier Tanzstile, ihre Geschichte und Bewegungssprache. Plus Floor-Etikette und ein Glossar der wichtigsten Begriffe."
    },
    "hero": {
      "eyebrow": "Info · Was tanzen wir? · Vier Tänze · Glossar · Etikette",
      "titleLine1": "Wissen,",
      "titleLine2": "das tanzt.",
      "intro": "Bevor du anmeldest oder einfach das nächste Mal aufs Floor gehst: ein kurzer, ehrlicher Überblick zu unseren drei Tanzstilen — Brazilian Zouk, Lambada und Samba de Gafieira. Plus, was du als Neueinsteiger wissen solltest."
    },
    "styleBody": {
      "signatureMovesLabel": "Signature Moves",
      "steckbriefLabel": "Steckbrief"
    },
    "styles": [
      {
        "id": "brazilian-zouk",
        "name": "Brazilian Zouk & Lambada",
        "kicker": "Vom Strand-Lambada der 80er zum urbanen Tanz von heute.",
        "history": "Brazilian Zouk wuchs in den 1990ern aus der Lambada — als die karibischen Songs nicht mehr zur Verfügung standen, übernahmen brasilianische Tänzer den Tanz, glätteten den Rhythmus, dehnten die Bewegungen. Heute ein eigener Stil mit langen Bögen, Headmovements und einer Connection, die nach Atem klingt.",
        "signature": ["Basic Step", "Bodywave", "Cambré", "Mergulho", "Furacão", "Soltinho"],
        "steckbrief": [
          { "label": "Herkunft", "value": "Brasilien · 1990er" },
          { "label": "Musik", "value": "Zouk · R&B · Pop" },
          { "label": "Tempo", "value": "85–100 BPM" },
          { "label": "Charakter", "value": "Fliessend · sinnlich" },
          { "label": "Einstieg", "value": "Modul A · 6 × 75 Min · ab CHF 230" }
        ]
      },
      {
        "id": "samba-de-gafieira",
        "name": "Samba de Gafieira",
        "kicker": "Der Ballsaal-Samba aus Rio. Spielfreude und Augenkontakt.",
        "history": "Gafieira sind die Ballsäle von Rio — und der Tanz, der dort entstand, ist der „Ballroom Samba\" Brasiliens. Klare Tanzhaltung, schnelle Beinarbeit, Schauspielerei. Anders als der Karneval-Samba No Pé wird hier zu zweit getanzt, mit Frame und Lead/Follow.",
        "signature": ["Bota-Fora", "Picadinhos", "Caminhada", "Balão Apagado", "Tempo", "Contratempo"],
        "steckbrief": [
          { "label": "Herkunft", "value": "Rio de Janeiro · 1940er" },
          { "label": "Musik", "value": "Samba · Pagode · Choro" },
          { "label": "Tempo", "value": "100–120 BPM" },
          { "label": "Charakter", "value": "Spielerisch · präzise" },
          { "label": "Einstieg", "value": "Modul A · 6 × 75 Min · ab CHF 230" }
        ]
      }
    ],
    "etikette": {
      "idx": "05 / Erste Stunde",
      "title": "Floor",
      "italic": "-Etikette.",
      "sub": "Sechs Hinweise — du kannst sie als „Tanz-Knigge\" lesen. Hilft beim Ankommen, gilt für alle Stile."
    },
    "firstClassTips": [
      { "n": "01", "title": "Komm 10 Minuten früher", "body": "Damit du dich umziehen und ankommen kannst, ohne den Kurs zu unterbrechen." },
      { "n": "02", "title": "Glatte Sohle", "body": "Keine Strassenschuhe. Lederlaufsohle oder Sportschuhe ohne Profil." },
      { "n": "03", "title": "Paar wechselt regelmässig", "body": "Du lernst mit allen Anwesenden. Auch Solo-Anmeldung ist kein Problem." },
      { "n": "04", "title": "Wasserflasche", "body": "Eine Stunde Bewegung — auch im Winter wirst du Wasser brauchen." },
      { "n": "05", "title": "Connection geht in beide Richtungen", "body": "Leader führt, Follower wählt. Beide hören aufeinander, beide tanzen." },
      { "n": "06", "title": "Frag bevor du auforderst", "body": "Konsens auf der Tanzfläche. Ein „Nein, danke\" ist immer respektiert." }
    ],
    "glossar": {
      "idx": "06 / Vokabular",
      "title": "Glossar —",
      "italic": "zwölf Begriffe.",
      "sub": "Die Wörter, die du im Studio öfter hören wirst. Mit Sprache und Bedeutung.",
      "items": [
        { "term": "Connection", "lang": "EN", "def": "Die körperliche und kommunikative Verbindung zwischen Leader und Follower." },
        { "term": "Cambré", "lang": "FR/PT", "def": "Eine kontrollierte Rückenbeuge mit weichem Kopf-Übergang." },
        { "term": "Soltinho", "lang": "PT", "def": "Schneller Tanz-Stil im Brazilian Zouk mit hüpfigem Charakter." },
        { "term": "Mergulho", "lang": "PT", "def": "„Tauchgang\" — eine tiefe Vorbeuge mit fliessender Rückkehr." },
        { "term": "Furacão", "lang": "PT", "def": "„Sturm\" — eine schnelle Drehfigur über mehrere Achsen." },
        { "term": "Gafieira", "lang": "PT", "def": "Die Rio-Ballsäle, namensgebend für den Tanzstil." },
        { "term": "Tempo", "lang": "PT", "def": "Schritt auf den ersten Schlag des Taktes." },
        { "term": "Contratempo", "lang": "PT", "def": "Schritt gegen den Grundtakt — bewusstes Spielen mit dem Off-Beat." },
        { "term": "Frame", "lang": "EN", "def": "Die Haltung der Arme/Schultern als Kommunikationswerkzeug." },
        { "term": "Lead / Follow", "lang": "EN", "def": "Die zwei Rollen — die Initiative und das Antworten." },
        { "term": "Practica", "lang": "PT", "def": "Geleitetes Üben in lockerer Atmosphäre — keine Lektion, kein Social." },
        { "term": "Roda", "lang": "PT", "def": "Der Kreis, in dem Paare nacheinander tanzen — typisch im Samba." }
      ]
    },
    "cta": {
      "titleLine1": "Ein Stil",
      "titleLine2": "passt.",
      "body": "Egal welcher der vier — am besten findest du es heraus, indem du eine Trial Class besuchst. 75 Minuten, CHF 25, keine Vorkenntnisse nötig.",
      "ctaPrimary": "Alle Kurse ansehen",
      "ctaSecondary": "Frage stellen"
    }
  },

  "about": {
    "seo": {
      "title": "About",
      "description": "Zoukessence gibt es seit 2015. Zehn Lehrpersonen, vier Disziplinen, eine Lehrer-Ausbildung — und ein Ort, an dem man bleibt."
    },
    "hero": {
      "eyebrow": "Über Zoukessence · Geschichte · Verein · Philosophie · Team",
      "titlePart1": "Eine Tanzschule für die ",
      "titleItalic1": "Tänzer",
      "titlePart2": ", nicht ",
      "titleItalic2": "umgekehrt.",
      "intro": "Zoukessence gibt es seit 2015. Was als kleine Brazilian-Zouk-Schule begann, ist heute ein Team aus zehn Lehrpersonen, ein eigenes Lehrprogramm, ein Verein für die Schweizer Community — und vor allem ein Ort, an dem man bleibt.",
      "photoCard": {
        "accessibilityLabel": "Zoukessence Team beim Club Class",
        "caption": "Foto · Manu & Team — Studio Silbando",
        "year": "2015",
        "byline": "Von Manuel Mühlebach · in Zürich"
      }
    },
    "stats": [
      { "label": "Gegründet", "value": "2015" },
      { "label": "Lehrpersonen", "value": "10" },
      { "label": "Disziplinen", "value": "4" },
      { "label": "Verein", "value": "Brazilian Zouk Switzerland" }
    ],
    "geschichte": {
      "idx": "02 / Geschichte",
      "title": "Elf Jahre,",
      "italic": "in vier Kapiteln.",
      "sub": "Manuel Mühlebach gründete Zoukessence 2015, als Brazilian Zouk in der Deutschschweiz noch eine Randerscheinung war. Was folgte: ein eigenes Lehrprogramm, ein Team, ein Verein.",
      "pillCurrent": "Heute"
    },
    "timeline": [
      { "year": "2015", "title": "Gründung Zoukessence", "body": "Manuel Mühlebach eröffnet die Schule in Zürich. Erster Standort: Aussersihl." },
      { "year": "2019", "title": "Lehrer-Ausbildung", "body": "Eigenes Curriculum für angehende Lehrpersonen. Erste Generation: 4 Tänzer." },
      { "year": "2024", "title": "Verein Brazilian Zouk Switzerland", "body": "Eigener Verein für Socials, Events und die Schweizer Brazilian-Zouk-Community." },
      { "year": "2025", "title": "Samba de Gafieira startet", "body": "Erste Modul-Linie für Gafieira. Erweiterung des Studios auf vier Stile." }
    ],
    "philosophie": {
      "idx": "03 / Philosophie",
      "title": "Technik, Verständnis,",
      "italic": "Menschlichkeit.",
      "sub": "Drei Säulen tragen unseren Unterricht — sie machen den Unterschied zwischen einer Schule und einem Tanz-Zuhause.",
      "quote": "Bei uns entstehen Freundschaften, und manchmal wird auch geheiratet — da freuen wir uns jetzt schon auf den Nachwuchs.",
      "quoteAttribution": "— Team Zoukessence",
      "items": [
        { "n": "01", "title": "Technik & Gesundheit", "body": "Wir tanzen lang. Deshalb bauen wir Technik so, dass dein Körper sie dreissig Jahre trägt." },
        { "n": "02", "title": "Gesamtwissen", "body": "Geschichte, Musik, Connection — der Tanz ist nicht nur die Figur, sondern das Verständnis um sie herum." },
        { "n": "03", "title": "Menschliche Werte", "body": "Konsens, Respekt, Hilfsbereitschaft. Wir bauen die Community, die wir selber besuchen möchten." }
      ]
    },
    "verein": {
      "idx": "04 / Verein",
      "title": "Brazilian Zouk",
      "italic": "Switzerland.",
      "sub": "Ein Verein von der Community für die Community. Wir glauben, dass die Tanzgemeinschaft sich selbst am besten organisiert — unabhängig der Tanzschulen.",
      "data": {
        "title": "Verein Brazilian Zouk Switzerland",
        "body": "Die Tanzschule lehrt. Der Verein lebt die Community: Socials, Events, Ausflüge, Schweizer Brazilian-Zouk-Treffen. Beide eigenständig, beide miteinander.",
        "membershipPrice": "CHF 80 / Jahr",
        "membershipNote": "−10% auf alle Module bei Zoukessence"
      },
      "memCard": {
        "pill": "Seit Ende 2024",
        "titlePart1": "Alle Partys.",
        "titleItalic": "Ein Verein.",
        "body": "Sämtliche regelmässige Partys und Events der Tanzschule wurden an den Verein Brazilian Zouk Switzerland übergeben. Die Community soll sich selbst organisieren — unabhängig der Schule.",
        "labelMembership": "Mitgliedschaft",
        "labelBenefit": "Vorteil bei Zoukessence",
        "valueBenefit": "−10%",
        "ctaPrimary": "Zum Verein",
        "ctaSecondary": "Mitglied werden"
      }
    },
    "team": {
      "idx": "05 / Team",
      "title": "Zehn Lehrpersonen,",
      "italic": "eine Leidenschaft.",
      "sub": "Unsere Lehrpersonen haben sehr unterschiedliche Backgrounds — aber alle eine Leidenschaft für die brasilianischen Paartänze. Seit 2019 bilden wir intern aus."
    },
    "invite": {
      "eyebrow": "06 / Komm vorbei",
      "titlePart1": "Werde Teil einer ",
      "titleItalic": "Tanzgemeinschaft.",
      "body": "Unsere Schule ist eine Plattform für alle Tanzfreudigen, die sich gerne austauschen und weiterbilden möchten. Schreib uns — wir antworten innerhalb von 24 Stunden.",
      "ctaPrimary": "Alle Kurse",
      "ctaSecondary": "Kontakt aufnehmen"
    }
  },

  "kontakt": {
    "seo": {
      "title": "Kontakt",
      "description": "Schreib uns. Wir melden uns sobald als möglich — meistens innert 24 Stunden. Tanzstudio Silbando, Förrlibuckstrasse 62, 8005 Zürich."
    },
    "hero": {
      "eyebrow": "Kontakt · Schreib uns · komm vorbei · folge uns",
      "titleLine1": "Nimm Kontakt",
      "titleLine2": "mit uns auf.",
      "intro": "Egal ob du dich für einen Kurs interessierst, eine Frage zu einem Event hast oder einfach unsicher bist, welches Level für dich passt — schreib uns. Wir lesen jede Nachricht persönlich.",
      "pulse": {
        "highlight": "Wir melden uns sobald als möglich.",
        "rest": "Meistens innert 24 Stunden."
      }
    },
    "form": {
      "eyebrow": "01 / Nachricht senden",
      "titlePart1": "Sag uns, was du ",
      "titleItalic": "brauchst.",
      "intro": "Wähle ein Thema, fülle die Felder aus — du erhältst eine Bestätigung, sobald die Nachricht bei uns angekommen ist.",
      "topics": [
        "Kursberatung",
        "Events & Tickets",
        "Privatstunden",
        "Workshops & Promotion",
        "Sonstiges"
      ],
      "fields": {
        "name": "Name *",
        "firma": "Firma",
        "tel": "Telefon",
        "email": "Email *",
        "betreff": "Betreff",
        "nachricht": "Nachricht *"
      },
      "errors": {
        "required": "Bitte Name, Email und Nachricht ausfüllen."
      },
      "privacyNote": "Mit dem Absenden akzeptierst du unsere Datenschutzerklärung.",
      "submit": "Nachricht senden",
      "submitting": "Senden…",
      "done": {
        "title": "Danke — wir melden uns.",
        "body": "Deine Nachricht ist auf dem Weg. Antwort innert 24 Stunden."
      }
    },
    "info": {
      "directMail": {
        "label": "Direktes Mail",
        "title": "Schreib uns direkt.",
        "email": "info@zoukessence.ch",
        "body": "Schneller als das Formular — landet im gleichen Postfach. Du bekommst eine Antwort, meistens am selben Tag."
      },
      "responseTime": {
        "label": "Antwortzeit",
        "titlePart1": "Wann ",
        "titleItalic": "hörst du",
        "titlePart2": " von uns?",
        "bodyPart1": "Werktags zwischen ",
        "bodyHours": "9:00 — 21:00 Uhr",
        "bodyPart2": " melden wir uns meistens innerhalb von 4 Stunden. Am Wochenende kann es länger dauern — spätestens Montagmorgen hörst du von uns."
      },
      "languages": {
        "label": "Sprachen",
        "titlePart1": "Deutsch & ",
        "titleItalic": "English.",
        "body": "Unterricht und Kommunikation laufen primär auf Deutsch, English-only Anfragen sind aber willkommen — die meisten Lehrer unterrichten zweisprachig."
      }
    },
    "standorte": {
      "idx": "02 / Standorte",
      "title": "Zwei Adressen,",
      "italic": "eine Schule.",
      "sub": "Der Unterricht findet im Tanzstudio Silbando statt — unsere Geschäftsadresse liegt ein paar Tramstationen entfernt. Komm immer ins Silbando, ausser explizit anders angekündigt.",
      "studios": [
        {
          "label": "Hier findet der Unterricht statt",
          "pill": "Studio · Unterricht",
          "name": "Tanzstudio Silbando",
          "nameItalic": "Silbando",
          "role": "Alle Kurse · Workshops · Privatstunden",
          "address": "Förrlibuckstrasse 62",
          "city": "8005 Zürich · CH",
          "body": "Industriequartier — gut erreichbar mit Tram und S-Bahn, fünf Minuten Fussweg vom HB Hardbrücke. Parkplätze in der Tiefgarage gegenüber.",
          "initial": "S"
        },
        {
          "label": "Geschäftsadresse · Office",
          "pill": "Office · Verwaltung",
          "name": "Zoukessence Office",
          "nameItalic": "Office",
          "role": "Post · Rechnungen · Administratives",
          "address": "Altstetterstrasse 182",
          "city": "8048 Zürich · CH",
          "body": "Unsere offizielle Geschäftsadresse — kein Unterrichtsbetrieb. Post und Rechnungen kommen hierher; für alles andere komm ins Silbando.",
          "initial": "Z"
        }
      ]
    },
    "social": {
      "idx": "03 / Social Media",
      "title": "Folge uns,",
      "italic": "tanze mit uns.",
      "sub": "Studio-Updates, Video-Clips, neue Kurse und Reise-Berichte — vier Kanäle, eine Community. WhatsApp ist der direkteste Draht.",
      "items": [
        { "name": "Instagram", "initial": "I", "handle": "@zoukessence", "body": "Stories aus dem Studio, neue Kurs-Daten, Tanz-Clips.", "cta": "Folgen" },
        { "name": "Facebook", "initial": "F", "handle": "/zoukessence", "body": "Event-Ankündigungen, längere Posts, Verein-Updates.", "cta": "Folgen" },
        { "name": "YouTube", "initial": "Y", "handle": "@zoukessence7099", "body": "Show-Auftritte, Workshop-Aufnahmen, Tutorial-Snippets.", "cta": "Abonnieren" },
        { "name": "WhatsApp", "initial": "W", "handle": "Community Chat", "body": "Direkter Draht zu Lehrern und Mit-Tänzern.", "cta": "Beitreten" }
      ]
    },
    "hours": {
      "eyebrow": "04 / Öffnungszeiten",
      "titlePart1": "Wann das Studio ",
      "titleItalic": "offen ist.",
      "rows": [
        { "day": "Mo", "text": "Improver 4 · 19:00 · Intermediate · 20:30" },
        { "day": "Di", "text": "Samba Modul A · 20:15" },
        { "day": "Mi", "text": "Improver 1—3 · 19:00 · Advanced · 20:45" },
        { "day": "Do", "text": "Modul A Starter · 19:00 · Lambada · 20:30" },
        { "day": "Fr", "text": "Practica & Social · 21:00 (2× / Monat)" },
        { "day": "Sa", "text": "Weekender · nach Programm" },
        { "day": "So", "text": "Geschlossen · ausser Focus Day (1. So / Monat)" }
      ],
      "footnote": "Ausserhalb der Kurszeiten kein Zugang — schreib uns für eine Privatstunde."
    },
    "faq": {
      "eyebrow": "05 / Schnelle Antworten",
      "titlePart1": "Bevor du ",
      "titleItalic": "schreibst.",
      "items": [
        { "q": "Wo findet der Unterricht statt?", "a": "Im Tanzstudio Silbando, Förrlibuckstrasse 62, 8005 Zürich. Die Office-Adresse Altstetterstrasse 182 ist nur unsere Geschäftsadresse — dort findet kein Unterricht statt." },
        { "q": "Brauche ich einen Partner?", "a": "Nein. Wir balancieren die Kurse und wechseln im Unterricht regelmässig die Paare." },
        { "q": "Wann hörst du von uns?", "a": "Werktags meistens innerhalb von 4 Stunden, spätestens am nächsten Morgen. Am Wochenende kann es bis Montag dauern." },
        { "q": "Bietet ihr Privatstunden an?", "a": "Ja — schreib uns direkt mit deinem Lehrer-Wunsch und einem Zeitfenster. Details & Preise findest du auf der Kurse-Seite." },
        { "q": "Wie zahle ich?", "a": "Wir akzeptieren TWINT, Karte und Bar im Studio. Für Tickets & Festivalpässe gibt es einen Link in der Bestätigungs-Mail." }
      ]
    }
  },

  "team": {
    "teachers": [
      { "key": "manu", "name": "Manuel Mühlebach", "role": "Gründer · Lehrer", "style": "Brazilian Zouk · Lambada" },
      { "key": "corinne", "name": "Corinne Hardegger", "role": "Lehrerin · Co-Lead", "style": "Brazilian Zouk" },
      { "key": "michelle", "name": "Michelle Danuser", "role": "Lehrerin", "style": "Brazilian Zouk · Samba de Gafieira" },
      { "key": "cyrill", "name": "Cyrill Kernwein", "role": "Lehrer", "style": "Brazilian Zouk · Improver" },
      { "key": "andrea", "name": "Andrea Sorro", "role": "Lehrer", "style": "Brazilian Zouk · Lambada" },
      { "key": "amanda", "name": "Amanda Rölli", "role": "Lehrerin", "style": "Samba de Gafieira" },
      { "key": "dajana", "name": "Dajana Skalonja", "role": "In Ausbildung", "style": "Brazilian Zouk" },
      { "key": "julian", "name": "Julian Förster", "role": "In Ausbildung", "style": "Brazilian Zouk" },
      { "key": "fabienne", "name": "Fabienne Brunner", "role": "In Ausbildung", "style": "Brazilian Zouk" },
      { "key": "yves", "name": "Yves Bicker", "role": "In Ausbildung", "style": "Brazilian Zouk" }
    ]
  }
}
